import { PhoneCall, Wrench, ShieldCheck, TrendingUp } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: PhoneCall,
    title: "Anfrage & Planung",
    desc: "Ein kurzes Telefonat: Objekt, Ziel und gewünschter Umfang. Wir erstellen ein passgenaues Sicherheitskonzept.",
  },
  {
    n: "02",
    icon: Wrench,
    title: "Spurlose Installation",
    desc: "Moderne Funk-Technik – ohne Kabel, ohne Bohren an sichtbaren Stellen. In der Regel unter einer Stunde vor Ort.",
  },
  {
    n: "03",
    icon: ShieldCheck,
    title: "Sicherheit aktivieren",
    desc: "Push-Alarme, App-Steuerung, Historie – ab sofort ist Ihre Immobilie 24/7 überwacht. Kontrolliert per Smartphone.",
  },
  {
    n: "04",
    icon: TrendingUp,
    title: "Immobilie vermarkten",
    desc: "Nutzen Sie die Alarmanlage aktiv im Exposé und bei Besichtigungen – als Premium-Argument für einen besseren Preis.",
  },
];

export const ProcessTimeline = () => {
  return (
    <section
      id="process"
      data-testid="process-timeline"
      className="ss-section relative overflow-hidden ss-navy-panel"
    >
      <div className="absolute inset-0 ss-grain pointer-events-none" aria-hidden="true" />
      <div className="absolute -top-20 right-0 h-80 w-80 rounded-full bg-[var(--ss-gold)]/8 blur-3xl" aria-hidden="true" />

      <div className="ss-container relative">
        <div className="max-w-3xl">
          <span className="ss-eyebrow-on-navy">Unser Prozess</span>
          <h2 className="ss-h2 mt-4 text-white">Schnell. Spurlos. Effektiv.</h2>
          <p className="ss-lead mt-4 text-slate-300">
            Vier klare Schritte – vom ersten Telefonat bis zur aktiv beworbenen, gesicherten Immobilie. Kein Papierkram, keine Wartezeiten.
          </p>
        </div>

        <ol className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="process-steps">
          {steps.map((s, idx) => (
            <li
              key={s.n}
              className="relative rounded-2xl bg-white/5 backdrop-blur border border-white/10 p-6 hover:border-[var(--ss-gold)]/40 hover:bg-white/[0.07] transition-all duration-300 group"
              data-testid={`process-step-${idx + 1}`}
            >
              {/* Connector line (desktop) */}
              {idx < steps.length - 1 && (
                <span
                  className="hidden lg:block absolute top-10 -right-3 w-6 h-[2px] bg-gradient-to-r from-[var(--ss-gold)]/40 to-transparent"
                  aria-hidden="true"
                />
              )}

              <div className="flex items-center justify-between">
                <span className="ss-num-circle group-hover:shadow-[0_0_24px_rgba(245,197,66,0.35)] transition-shadow">
                  {s.n}
                </span>
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white/5 text-[var(--ss-gold)]">
                  <s.icon className="h-4.5 w-4.5" />
                </span>
              </div>

              <h3 className="font-display font-semibold text-lg text-white mt-6">{s.title}</h3>
              <p className="text-sm text-slate-300 mt-2 leading-relaxed">{s.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
